import { createStyles, Theme } from "@material-ui/core";
import { styleColors } from "src/main.style";

export const GmailConnectPageStyle = (theme: Theme) => createStyles({
  content: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2.5),
    margin: "0 auto",
    maxWidth: "560px",
    padding: theme.spacing(4),
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      minHeight: "100vh",
      justifyContent: "center",
      padding: theme.spacing(3, 2),
    },
  },
  heading: {
    margin: 0,
    outline: "none",
    "&:focus-visible": {
      borderRadius: theme.spacing(0.5),
      boxShadow: `0 0 0 3px ${theme.palette.primary.light}`,
    },
  },
  text: {
    margin: 0,
    overflowWrap: "anywhere",
  },
  loading: {
    alignItems: "center",
    display: "flex",
    gap: theme.spacing(2),
    minHeight: "64px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2.5),
  },
  choices: {
    border: `1px solid ${styleColors.outlineBlack23}`,
    borderRadius: "12px",
    margin: 0,
    padding: theme.spacing(1, 2, 1.5),
  },
  legend: {
    color: theme.palette.text.primary,
    fontSize: "1rem",
    fontWeight: 600,
    padding: theme.spacing(0, 0.5),
  },
  radioLabel: {
    marginLeft: theme.spacing(-1),
    minHeight: "48px",
    overflowWrap: "anywhere",
  },
  actions: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1.5),
    "& > *": {
      flex: "1 1 180px",
      minHeight: "48px",
    },
  },
  notice: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${styleColors.outlineBlack23}`,
    borderRadius: "12px",
    padding: theme.spacing(2),
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    whiteSpace: "nowrap",
    width: "1px",
  },
});



// WEBPACK FOOTER //
// ./src/components/integrations/gmail/GmailConnectPage.style.ts